import { key } from 'piqure';
import type { Config } from '@/config/ConfigSchema.ts';

export const CONFIG = key<Config>('Config');
